import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AgePipe } from "../shared/pipes/age.pipe";
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { NotificationService } from '../shared/services/notifications.service';
@Component({
  selector: 'app-fill-extra-info',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, ReactiveFormsModule, MatIconModule, MatInputModule, AgePipe],
  templateUrl: './fill-extra-info.component.html',
  styleUrl: './fill-extra-info.component.scss'
})
export class FillExtraInfoComponent {
  requestForm !: FormGroup;
  @Input() isDismissable: boolean = false;
  copiedEmail: string | null = null;
  memberId!: string;
  selectedPatient: any;
  reqId!: string;
  details: any;
  popupTitle = 'Fill More Details';
  popupSubtitle = 'You can provider the extra details below requested by evidence provider';

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<FillExtraInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private restService: MemberInsurerRestService, private notificationService: NotificationService) {
    this.requestForm = this.fb.group({
      comments: [''],
    })

    if (data) {
      this.memberId = data.patientId;
      this.details = data;
    }

    if (this.memberId)
      this.getMemberById();
  }

  getMemberById(): void {
    this.restService.getMemberById(this.memberId).subscribe({
      next: (response) => {
        this.selectedPatient = response;
      },
      error: (err) => {
        console.error('Failed to fetch patient by ID:', err);
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
    this.copiedEmail = value;
    setTimeout(() => {
      this.copiedEmail = null;
    }, 1200);
  }

  onFileDropped(event: Event) {
    event.preventDefault();

    // Explicitly cast the event to a DragEvent
    const dragEvent = event as DragEvent;

    // Safely check for dataTransfer and files
    const files = dragEvent.dataTransfer ? dragEvent.dataTransfer.files : null;

    if (files && files.length > 0) {
      this.handleFiles(files);
    }
  }

  handleFiles(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      this.uploadedFiles.push(files[i]);  // Add file to the uploadedFiles array
    }
  }

  // Remove a file from the list
  removeFile(index: number) {
    this.uploadedFiles.splice(index, 1);  // Remove the file from the array
  }

  uploadedFiles: File[] = [];// Store the list of uploaded files

  onAdditional(fileInput: any) {
    const files = fileInput.files;
    if (files && files.length > 0) {
      this.handleFiles(files);
    }
    if (files.length > 0) {
      // Handle each file
      Array.from(files).forEach(file => {
        if (file instanceof File) {
          this.uploadFileAndStoreDocument(file);
        }
      });
    }
  }

  async uploadFileAndStoreDocument(file: File) {
    // try {
    //   // Call the API to upload the file and get the URL
    //   const url = await this.getfiles3Url(file);
    //   console.log('File uploaded and URL received:', url);

    //   // Store the document info in the document list
    //   const documentObject = {
    //     "documentType": 'Additional File',
    //     "documentName": file.name,
    //     "documentPath": url.documentPath
    //   };

    //   // Add the document object to the list
    //   this.documentList.push(documentObject);

    //   console.log('Updated Document List:', this.documentList);
    // } catch (error) {
    //   console.error('Error uploading file or fetching URL:', error);
    // }
  }

  submitForm() {
    const formData = new FormData();

    // Append comment
    formData.append('comments', this.requestForm.value.comments);

    // Append all files
    this.uploadedFiles.forEach((file: File) => {
      formData.append('files', file); // or 'files[]' depending on backend
    });

    // Optional: log what's in FormData
    for (let pair of (formData as any).entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    this.restService.fillMoreDetails(formData, this.details.serviceRequest.id).subscribe({
      next: (res) => {
        if (res) {
          this.notificationService.showNotification('Submitted successfully');
        } else {
          this.notificationService.showNotification('Something went wrong, please try again later', 'error');
        }
      },
      error: (err) => {
        this.notificationService.showNotification(err?.error?.message || 'Error occurred', 'error');
      }
    });
  }

}
